import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getInfo({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.INFO,
        error: { message: 'インフォメーション取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // お知らせタイトル登録
    async save({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.INFO,
        error: { message: 'お知らせタイトルの登録に失敗しました。' },
      }
      await dispatch('http/post', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // お知らせタイトル削除
    async delete({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.INFO}/${data.ID}`,
        error: { message: 'お知らせタイトルの削除に失敗しました。' },
      }
      await dispatch('http/delete', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/info.js